export const lssLangVi = {
  contact: {
    contactList: 'Contact List',
    name: 'Name',
    phone: 'Phone',
    close: 'Close',  
    check: 'Check',
    searchName: 'Search Name'
  },
};
